import '../styles/LandingPage/Outputs.css';
import { useEffect, useRef } from 'react';

const pills = [
  { dot: 'dot-teal',    label: 'Whitepapers' },
  { dot: 'dot-green',   label: 'Technical Notes' },
  { dot: 'dot-crimson', label: 'Actuarial Insight Briefs' },
  { dot: 'dot-teal',    label: 'Public Dashboards' },
  { dot: 'dot-green',   label: 'Industry Commentary Reports' },
  { dot: 'dot-crimson', label: 'Conference Papers' },
  { dot: 'dot-teal',    label: 'Regulatory Response Submissions' },
];

export default function Outputs() {
  const sectionRef = useRef(null);
  const pillsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.animationPlayState = 'running';
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -30px 0px' }
    );

    pillsRef.current.forEach((pill) => {
      if (pill) {
        pill.style.animationPlayState = 'paused';
        observer.observe(pill);
      }
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="outputs-section" id="outputs" ref={sectionRef}>
      {/* Floating background shapes */}
      <div className="outputs-bg-shapes">
        <div className="shape shape-1" />
        <div className="shape shape-2" />
        <div className="shape shape-3" />
        <div className="shape shape-4" />
      </div>

      {/* Diagonal accent line */}
      <div className="outputs-accent-line" />

      <div className="outputs-layout">

        <div>
          <div className="s-label">Research Outputs</div>
          <h2>Insight Across Every Format.</h2>
          <p className="s-intro">
            Actyra publishes across multiple channels to ensure rigorous actuarial
            knowledge reaches practitioners, regulators, and industry leaders alike.
          </p>
          <a href="#contact" className="btn-primary">Request a Brief</a>
        </div>

        <div className="outputs-pills">
          {pills.map((p, i) => (
            <div
              className="pill"
              key={i}
              ref={(el) => { pillsRef.current[i] = el; }}
            >
              <div className={`pill-dot ${p.dot}`} />
              {p.label}
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}